import axios from "axios";
import { useAuthStore } from "../Stores/AuthStore";
import { useAuthStore as useAuthV2Store } from "../Stores/auth-v2-store";
import env from "../config/env";

export const API_URL = env.PUBLIC_API_URL;

export const publicApi = axios.create({
  baseURL: API_URL,
  // timeout: 1000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const authenticatedApi = axios.create({
  baseURL: API_URL,
  // timeout: 1000,
  headers: {
    'Content-Type': 'application/json',
  },
});
authenticatedApi.interceptors.request.use((config) => {
  // Dual-read : priorite au store V2, fallback sur le store legacy
  const token = useAuthV2Store.getState().accessToken
             || useAuthStore.getState().access_token;

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  return config;
});

// Intercepteur de réponse pour gérer l'expiration du token
authenticatedApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // Si le token est expiré ou invalide (401), on déconnecte et redirige
    if (error.response?.status === 401) {
      console.log('[Interceptor] 401 detected, logging out with reason: expired');
      useAuthStore.getState().logout();
      window.location.href = '/?error=expired';
    }
    return Promise.reject(error);
  }
);